module.exports = __webpack_public_path__ + "static/media/bomb.e03b259b.svg";